// extracted by mini-css-extract-plugin
export var hidden = "_oj-1";
export var visible = "_oj-0";